var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 56,
    fill: "none",
    viewBox: "0 0 57 56"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 0.5,
    fill: "#303030",
    rx: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M25.448 12c-3.753 0-6.766 2.584-6.766 7.524 0 3.225 1.282 6.51 3.228 8.535.759 2.024-.61 2.777-.893 2.885-3.928 1.444-8.517 4.063-8.517 6.665v.973c0 3.546 6.736 4.365 12.986 4.365a57 57 0 0 0 4.082-.154 9.68 9.68 0 0 1-2.643-6.666 9.7 9.7 0 0 1 2.02-5.924c-.186-.44-.26-1.131.08-2.183 1.934-2.027 3.188-5.283 3.188-8.498 0-4.938-3.016-7.52-6.766-7.52zm11.198 16.253c-2.083 0-4.08.83-5.554 2.306a7.883 7.883 0 0 0 0 11.135 7.844 7.844 0 0 0 11.108 0 7.883 7.883 0 0 0 0-11.135 7.84 7.84 0 0 0-5.554-2.306m-1.089 3.509h2.178v3.235h3.227v2.26h-3.227v3.236h-2.178v-3.236h-3.266v-2.26h3.266z"
  })));
};
export default SvgUserIcon;